import { loadPageOnResolve } from "./script.js";

document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("main-video");
  const playPauseBtn = document.getElementById("play-pause-btn");
  const progressBar = document.getElementById("progress-bar");
  const progressContainer = document.getElementById("progress-container");
  const muteBtn = document.getElementById("mute-btn");

  muteBtn.textContent = video.muted ? "🔇" : "🔈";

  let isDragging = false;

  // Play/pause toggle
  playPauseBtn.addEventListener("click", () => {
    if (video.paused) {
      video.play();
      playPauseBtn.textContent = "❚❚";
    } else {
      video.pause();
      playPauseBtn.textContent = "▶";
    }
  });

  // Update progress bar
  video.addEventListener("timeupdate", () => {
    if (!isDragging) {
      const progress = (video.currentTime / video.duration) * 100;
      progressBar.style.width = `${progress}%`;
    }
  });

  // Handle click & drag on progress bar
  const seekVideo = (e) => {
    const rect = progressContainer.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const width = rect.width;
    const percent = Math.max(0, Math.min(offsetX / width, 1));
    video.currentTime = percent * video.duration;
    progressBar.style.width = `${percent * 100}%`;
  };

  progressContainer.addEventListener("mousedown", (e) => {
    isDragging = true;
    seekVideo(e);
  });

  document.addEventListener("mousemove", (e) => {
    if (isDragging) {
      seekVideo(e);
    }
  });

  document.addEventListener("mouseup", () => {
    isDragging = false;
  });
  // Mute/unmute toggle
  muteBtn.addEventListener("click", () => {
    video.muted = !video.muted;
    muteBtn.textContent = video.muted ? "🔇" : "🔈";
  });

  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  }, observerOptions);

  document.querySelectorAll(".fade-in").forEach((el) => {
    observer.observe(el);
  });

  loadPageOnResolve();
});
